module.exports = __webpack_public_path__ + "images/emoji/hurtrealbad.47e1563693af7b394509.png";